<template>
  <b-row>
    <b-col sm="12">
      <b-card no-header>
        <template slot="header">
          Mes alertes
        </template>
        <b-row>
          <b-col sm="12" v-if="isEmpty(groupedNotifications)">Vous n'avez encore aucune notification</b-col>
          <b-col v-else sm="12" md="12" v-for="(categorie,index) in groupedNotifications" :key="'categorie_'+index">
            <h5>{{ categorie[0] }}</h5>
            <b-list-group>
              <span v-for="notification in categorie[1]" :key="'notification_'+notification.id">
                <!-- <b-list-group-item  :class="$parent.$parent.getNotificationClass(notification)">
                  <i v-if="!notification.has_been_seen" class="fa fa-circle fa-0_5x text-danger"></i> {{ notification.title }} <i class="fa fa-search clickable pull-right mr-1" v-b-toggle="'collapse-notification-'+notification.id" @click="setNotificationAsShown(notification)"></i>
                </b-list-group-item>
                <b-collapse :id="'collapse-notification-'+notification.id" class="mt-2">
                  <notificationCard class="mt-0" :notification="notification"></notificationCard>
                </b-collapse> -->
                <b-list-group-item  :class="$parent.$parent.getNotificationClass(notification)">
                  <!-- <i v-if="!notification.has_been_seen" class="fa fa-circle fa-0_5x text-danger"></i> <span class="font-weight-normalx">{{ formatDateTime(notification.created_at, '-') }}</span> - {{ notification.target.type.groupe }} - {{ notification.title }} - <a target="_BLANK" :href="getUrlTarget(notification)" class="card-link">{{ notification.target_id }}</a> - {{ notification.target.nom + ' ' + notification.target.prenom }} - {{ notification.target.raison_sociale }} -->
                  <i v-if="!notification.has_been_seen" class="fa fa-circle fa-0_5x text-danger"></i>
                    <span v-if="notification.categorie.libelle_technique == 'livraison'">
                      <span class="font-weight-normalx"> {{ formatDateTime(notification.created_at, '-') }}</span> - <b><a href="#" @click="showLivraison(notification)" class="card-link">{{ notification.title }}</a></b>
                    </span>
                    <span v-else>
                      <span class="font-weight-normalx">{{ formatDateTime(notification.created_at, '-') }}</span> - {{ notification.target.type.groupe }} - {{ notification.title }} - <a target="_BLANK" :href="getUrlTarget(notification)" class="card-link">{{ notification.target_id }}</a> - {{ notification.target.nom + ' ' + notification.target.prenom }} - {{ notification.target.raison_sociale }}
                    </span>
                  <span @click="setNotificationAsShown(notification)"><b-form-checkbox v-if="type === 'active'" class="float-right" v-b-tooltip.hover title="Mettre comme traité"></b-form-checkbox></span>
                </b-list-group-item>
              </span>
            </b-list-group>
          </b-col>
        </b-row>

        <template slot="footer">
          <b-button @click="goBack"><i class="fa fa-arrow-left mr-1"></i>Retour</b-button>
          <b-button v-if="type === 'active'" class="float-right" variant="warning" @click="seeNotifications('archived')"><i class="fa fa-folder-open mr-1"></i>Voir mes archives</b-button>
          <b-button v-if="type === 'archived'" class="float-right" variant="success" @click="seeNotifications('active')"><i class="fa fa-folder mr-1"></i>Voir mes alertes</b-button>
        </template>
      </b-card>
    </b-col>
    <b-modal size="lg" scrollable centered id="modal-livraison" ref="modal-livraison" :title="'v ' + versionAtlas + ' du ' + dateVersion">
      <b-row class="mb-1">
        <b-col sm="12">
          <div class="block-livraison" v-html="contenu"></div>
        </b-col>
      </b-row>
      <b-row class="mr-1 ml-1 mb-1 mt-3" v-if="canAccess(rules.CAN_ACCESS_HISTO_LIVRAISONS)">
        <router-link :to="listLivraisons()" target="_blank">
          <i class="fa fa-plus"></i> Voir plus de livraisons
        </router-link>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" @click="$bvModal.hide('modal-livraison')" class="btn btn-secondary"> Fermer</button>
        </div>
      </template>
    </b-modal>
  </b-row>
</template>

<script>
import { getUser } from "@/utils/auth";
import { isEmpty as isEmptyHelper } from "@/utils/fileHelper";
import notificationCard from '@/components/User/NotificationCard';
import { formatDateTime } from "@/utils/communHelper";
import { hasRule, rules, sites } from '@/utils/rulesHelper'

export default {
  name: 'Notifications',
  components: {
    notificationCard
  },
  data () {
    return {
      formatDateTime,
      allNotifications: [],
      groupedNotifications: [],
      type: 'active',
      versionAtlas: '',
      dateVersion: '',
      idVersion: '',
      contenu: '',
      rules: rules,
    }
  },
  watch: {
    allNotifications() {
      if (this.allNotifications) {
        this.groupNotifications();
      }
    }
  },
  created() {
    let user = getUser();
    this.type = this.$route.params.type;
      // console.log('type',this.$route.params.type)
  },
  mounted () {
    this.getAllNotifications();
  },
  methods: {
    isEmpty(data) {
      return isEmptyHelper(data);
    },
    getAllNotifications() {
      let self = this;
      this.$axios
        .get('/notification/all-user-notifications/'+this.type)
        .then(response => {
          this.allNotifications = response.data.notifications;
          // this.$parent.$parent.nbNotification = this.countUserNotification();
        })
        .catch(function (error) {
          console.log(error);
          let textError = 'Une erreur est survenue lors de la récupérations des notifications, si le problème persiste merci de faire un ticket au support DOSI';

          self.$store.commit('IS_LOADING', false);
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: textError,
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    groupNotifications() {
      // On remet à zéro le tri déjà calculé pour remplacer par el nouveau
      this.groupedNotifications = [];
      // On groupe par le libellé de la catégorie
      let groupedByNotification = _.groupBy(this.allNotifications, 'categorie.libelle');
      // On tri en fonction de l'ordre des catégories
      let sortable = Object.entries(groupedByNotification);
      sortable.sort((group1,group2) => group1[1][0].categorie.ordre - group2[1][0].categorie.ordre)
      this.groupedNotifications = sortable;
      // On lance le recompte des notifications encore non vues
      // this.$parent.$parent.countUserNotification();
    },
    setNotificationAsShown(notification) {
      let user = getUser();
      let canUpdate = user.id_original && parseInt(user.id_original,10) !== parseInt(user.id,10) ? false : true;
      if (canUpdate) {
        // // On met à jour les notifications présentes
        // _.each(this.allNotifications, notif => {
        //   notif.has_been_seen = notif.id === notification.id ? true : notif.has_been_seen;
        // });
        // // On relance le tri
        // this.groupNotifications();
        // // On lance la mise à jour des notifications au niveau du header du site. C'est églameent lui qui va faire l'axios pour mettre à jour la notification en "vue"
        // this.$parent.$parent.setNotificationAsShown(notification);

        // Do axios
        this.$axios.get('/notification/seen/'+notification.id)
        .then((response) => {
          for (let notif of this.allNotifications) {
            if (notif.id === notification.id) {
              notif.has_been_seen = true;
            }
          }
          setTimeout(() => {
            this.allNotifications = this.allNotifications.filter(notif => notif.id !== notification.id);
            // let nbNotification = this.countUserNotification();
            // console.log('nbNotification',nbNotification)
            this.$event.emit('refreshNbNotification', this.allNotifications);
          }, 3000)
        })
        .catch((error) => {
          console.log('passage notification en "vue" ko');
        });

      }

    },
    goBack() {
      this.$router.go(-1)
    },
    getUrlTarget(selectedNotification) {
      let url = '#';
      let routeData = {};
      switch (true) {
        case /Dossier/.test(selectedNotification.target_type) :
          let traitementId = 1; //si pas de type, de forte chance qu'on soit en traitement PFE
          // TODO : voir comment récupérer le traitement de manière dynamique sans plomber les perfs
          if (selectedNotification.target && selectedNotification.target.type && selectedNotification.target.type.groupe.toLowerCase() === 'ij' ) {
            traitementId = 2
          } else if (selectedNotification.target && selectedNotification.target.type && selectedNotification.target.type.groupe.toLowerCase() === 'inval' ) {
            traitementId = 12
          } else if (selectedNotification.target && selectedNotification.target.type && selectedNotification.target.type.groupe.toLowerCase() === 'dc' ) {
            traitementId = 13
          }
          routeData = this.$router.resolve({name: 'fiche dossier', params: { id: selectedNotification.target_id }, query: {traitementId: traitementId}});
          url = routeData.href;
          break;
        case /Mail/.test(selectedNotification.target_type) :
          routeData = this.$router.resolve({name: 'Réception des mails', params: { id: selectedNotification.target_id }});
          url = routeData.href;
          break;
      }

      return url;
    },
    countUserNotification() {
      let nbNotification = 0;
      for (let notification of this.allNotifications) {
        if (!notification.has_been_seen) {
          nbNotification++;
        }
      }
      return nbNotification;
    },
    seeNotifications(type) {
      this.$router.push({path: '/administration/notification-user/'+type});
      if (/administration\/notification-user/.test(this.$router.history.current.path)) {
        this.$router.go();
      }
    },
    canAccess(rule) {
      return hasRule(rule)
    },
    formatDate(date) {
      return formatDateTime(date, '-');
    },
    listLivraisons() {
      return {
        path: '/last-versions/list'
      }
    },
    showLivraison(selectedLivraison) {
      this.versionAtlas = selectedLivraison.target.numero_version
      this.dateVersion = this.formatDate(selectedLivraison.target.date_livraison)
      this.idVersion = selectedLivraison.target.id
      this.contenu = selectedLivraison.target.contenu

      this.$refs['modal-livraison'].show()
    }
  }
}
</script>
